export default class ottService{

	constructor($http, baseUrl){
		this.http    = $http;
		this.baseUrl = baseUrl;

		this.routes = {
			"all": '/api/ott/list',
			"id": '/api/ott/:id',
			"new": '/api/ott',
			"delete": '/api/ott/:id',
			"falla": "/api/ott/falla",
			"tarea": "/api/ott/tarea",
			"update": '/api/ott',
			"moverEquipo": "/api/ott/mover",
			"observacion": "/api/ott/observacion",
			"cerrar": "/api/ott/cerrar",
			"finalizar": "/api/ott/finalizar",
			"pdf": "/api/ott/pdf",
			"getPdf": "/api/ott/pdf/:pdf",
			"tareas": "/api/ott/tareas",
			"reagendar" : "/api/ott/reagendar",
			"pdfLapiz": "/api/ott/pdfLapiz",
			"misPendientes": "/api/ott/pendientes/usuario",
			"deleteImagen" : "/api/ott/imagen/delete",
			"listPdfFilter": "/api/ott/list-pdf-filter",
			"deleteArchivo": "/api/ott/archivo/delete",
			"ottmovimientos": "/api/ott/mov-by-location",
			"getPdfLink": "/api/ott/get-link-pdf"
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {};
		// if (filter !== undefined) {
		// 	if (typeof filter == 'string') {
		// 		config.params = {
		// 			string: filter
		// 		}
		// 	}else{
		// 		params = filter;
		// 	}
		// }

		return this.http.post(url, filter);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

	registrarFalla(data){
		let url = this.baseUrl + this.routes.falla;
		return this.http.post(url, data);
	}

	moverEquipo(data){
		let url = this.baseUrl + this.routes.moverEquipo;
		return this.http.post(url, data);
	}

	agregarTarea(data){
		let url = this.baseUrl + this.routes.tarea;
		return this.http.post(url, data);
	}

	actualizarTarea(data){
		let url = this.baseUrl + this.routes.tarea;
		return this.http.put(url, data);
	}

	update(data){
		let url = this.baseUrl + this.routes.update;
		return this.http.put(url, data);
	}

	agregarObservacion(data){
		let url = this.baseUrl + this.routes.observacion;
		return this.http.post(url, data);
	}

	cerrarOtt(data){
		let url = this.baseUrl + this.routes.cerrar;
		return this.http.post(url, data);
	}

	finalizarOtt(data){
		let url = this.baseUrl + this.routes.finalizar;
		return this.http.post(url, data);
	}

	pdf(data){
		let url = this.baseUrl + this.routes.pdf;
		return this.http.post(url, data);
	}

	getPdf(data){
		let idRoute = this.routes.getPdf.replace(':pdf', data.pdf);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	guardarTareas(data){
		let url = this.baseUrl + this.routes.tareas;
		return this.http.put(url, data);
	}

	reagendar(data){
		let url = this.baseUrl + this.routes.reagendar;
		return this.http.post(url, data);
	}
	delete(data){
		let url = this.baseUrl + this.routes.delete.replace(':id', data._id);
		return this.http.delete(url);
	}

	pdfLapiz(data){
		let url = this.baseUrl + this.routes.pdfLapiz;
		return this.http.post(url, data);
	}

	misPendientes(filter){
		let url = this.baseUrl + this.routes.misPendientes;
		let config = {};
		if (filter !== undefined) {
			if (typeof filter == 'string') {
				config.params = {
					string: filter
				}
			}else{
				params = filter;
			}
		}

		return this.http.get(url, config);
	}

	eliminarImagen(data){
		let url = this.baseUrl + this.routes.deleteImagen;
		return this.http.post(url, data);
	}

	getAllPdfFilter(filter){
		let url = this.baseUrl + this.routes.listPdfFilter;		

		return this.http.post(url, filter);
	}

	eliminarArchivo(data){
		let url = this.baseUrl + this.routes.deleteArchivo;
		return this.http.post(url, data);
	}

	movementsByLocation(data) {
		let url = this.baseUrl + this.routes.ottmovimientos;
		return this.http.post(url, data);
	}

	getLinkPDF(string) {
		let url = `${this.baseUrl}${this.routes.getPdfLink}`;
		return this.http.post(url, string);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/ottService.js